export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-3.77e9f083.png";